// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3LkKM{border:2px solid #ddd;border-radius:25px;max-width:800px;min-height:180px;-webkit-box-shadow:0 15px 35px 0 hsla(0,0%,50.2%,.15);box-shadow:0 15px 35px 0 hsla(0,0%,50.2%,.15);padding:25px;margin:0 auto 30px;position:absolute;left:0;right:0;direction:rtl}@media only screen and (min-width:850px){._3LkKM{bottom:10px}}._1_FvR{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;margin-bottom:20px}._1FzEd{color:#000;font-size:22px;font-weight:700;line-height:30px}._1A7nf{color:#9b9b9b}._2WmSd,._1A7nf{font-size:18px;line-height:30px}._2WmSd{color:#4d4d4d;margin-right:84px}._2NS6i{border-radius:100%;margin-left:20px}@media only screen and (max-width:850px){._1FzEd{font-size:18px}._3LkKM{width:90%;margin:auto auto 20px;top:0}._2NS6i{display:none}._2WmSd{text-align:justify;margin:0}}", ""]);
// Exports
exports.locals = {
	"commentContainer": "_3LkKM",
	"commentHeader": "_1_FvR",
	"name": "_1FzEd",
	"jobTitle": "_1A7nf",
	"description": "_2WmSd",
	"profileImage": "_2NS6i"
};
module.exports = exports;
